import React from "react";
import { Link } from "react-router-dom";
import arrowLong from "../../assets/commons/arrow.webp";
import routes from "../../routes/routes";

const MainCard = ({ id, cover, title, description, rubrique, date, auteur }) => {
    return (
        <Link to={`${routes.article}/${id}`} className="block bg-white overflow-hidden max-w-[355px] mx-auto">
            {/* Image de couverture */}
            <div className="relative">
                <img src={cover} alt={title} className="w-full h-56 object-cover" />
                <span className="absolute top-6 left-6 bg-danger text-white text-xs font-bold px-3 py-2">
                    {rubrique}
                </span>
            </div>

            {/* Contenu */}
            <div className="mt-4 px-4">
                <p className="text-gray-500 text-sm font-semibold">{auteur} - <span className="font-light">{date}</span></p>
                <h3 className="text-xl font-semibold mt-2">{title}</h3>
                <p className="text-gray-600 mt-2 text-sm font-light">{description}</p>
                <span className="text-greenprimary font-light underline mt-3 inline-flex items-center">
                    <img src={arrowLong} alt="" className="mr-5" />Lire plus
                </span>
            </div>
        </Link>
    );
};

export default MainCard;